import { animated } from 'react-spring';
import classnames from 'classnames';

import Icon from './Icon';
import useHeroItemSpring from '../hooks/useHeroItemSpring';

function Item({
  calc,
  offset,
  position = { top: '-10px', right: '10px' },
  size = 'regular',
  icon,
}) {
  const sizeClass = (sizeParam) => {
    switch (sizeParam) {
      case 'small':
        return 'p-1';
      case 'large':
        return 'p-3';
      case 'regular':
      default:
        return 'p-2';
    }
  };
  return (
    <animated.div
      className={classnames('absolute bg-haiti rounded z-10', sizeClass(size))}
      style={{
        ...position,
        transform: offset.interpolate(calc),
      }}
    >
      <Icon icon={icon} size={size} className="text-white" />
    </animated.div>
  );
}

export default function CoverItems({ items, container }) {
  const { calc, offset } = useHeroItemSpring({ container });
  if (!items || !items.length || !container) return null;

  const Component = (item, index) => (
    <Item {...item} calc={calc} offset={offset} key={index} />
  );

  return items.map(Component);
}
